import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
// Components
import ProductTable from '../Components/ProductTable';
import ProductFilter from '../Components/ProductFilter';
import FilterRow from '../Components/FilterRow';
import Pagination from '../Components/Pagination';
import { BtnLink } from '../Components/Button';
import BarcodeModal from '../Components/BarcodeModal';
import ImageModal from '../Components/ImageModal';
// Fns
import { filterProducts } from '../functions/filterProducts';
import { splitArray } from '../functions/spplitArray';
import { onDetected } from '../functions/onDetected';
// Hooks
import { useFilterProducts } from '../hooks/useFilterProducts';
import { usePagination } from '../hooks/usePagination';
import { useBarcodeModal } from '../hooks/useBarcodeModal';
import { useModalHandler } from '../hooks/useModalHandler';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { productsAction } from '../Redux/actions/productsAction';
import { typesAction } from '../Redux/actions/typesAction';
// Icons
import { BsPlus } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';

// Products per page
const PER_PAGE = 15;

const Header = styled.h1`
  display: flex; /* Enable flexbox */
  justify-content: space-between; /* Align content with space between */
  align-items: center; /* Center align items vertically */
  width: 100%; /* Take full width */
  /* Add any additional styling here */
`;

const Home = () => {
  const { token, userType } = useSelector((state) => state.user);
  const { products, isLoading } = useSelector((state) => state.products);
  const [sortProducts, setStoreProducts] = useState('');
  const [printMode, setPrintMode] = useState(false);
  const [selected, setSelected] = useState([]); // array of IDs

  const sortHandler = (e) => {
    const idx = e.target.selectedIndex;
    const el = e.target.childNodes[idx].value;
    setStoreProducts(el);
  };
  const { filterInputs, filterValuesHandler, filterSelectHandler, clearInputs } =
    useFilterProducts();
  const history = useHistory();

  const [displayProducts, setDisplayProducts] = useState([]);
  // Show & hide filter
  const [showFilter, setShowFilter] = useState(true);
  const clearInputsBetter = () => {
    clearInputs();
    setStoreProducts('');
    setShowFilter(false);
    setTimeout(() => {
      setShowFilter(true);
    }, 1);
  };
  const displayFilterHandler = () => {
    if (!showFilter) {
      setShowFilter(true);
    } else {
      clearInputs();
      setShowFilter(false);
    }
  };
  const types = Object.values(useSelector((state) => state.types.types));
  const { imgOpen, modalHandler } = useModalHandler();

  const spltArray = splitArray(displayProducts, PER_PAGE);
  const { currentPage, setCurrentPage, countHandler } = usePagination(
    spltArray,
    filterInputs,
    sortProducts,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (token) {
      dispatch(productsAction(token));
      dispatch(typesAction());
    }
    // fetchTypes();
  }, [token, dispatch]);

  useEffect(() => {
    setDisplayProducts(products);
  }, [products]);

  useEffect(() => {
    filterProducts(products, filterInputs, sortProducts, setDisplayProducts);
  }, [filterInputs, products, sortProducts]);

  return (
    <>
      {imgOpen.open && <ImageModal img={imgOpen} modalHandler={modalHandler} />}
      <div
        style={{
          position: 'fixed',
          top: '140px',
          right: '20px',
          zIndex: 1000,
          display: 'flex',
          gap: '10px',
        }}
      >
        <button
          style={{
            padding: '10px 15px',
            backgroundColor: printMode ? '#dc3545' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 'bold',
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            transition: 'all 0.2s ease',
            fontSize: '14px',
          }}
          onMouseOver={(e) => (e.currentTarget.style.opacity = '0.9')}
          onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
          onClick={() => setPrintMode(!printMode)}
        >
          {printMode ? '❌ Exit Print Mode' : '🖨️ Print Mode'}
        </button>

        {selected.length > 0 && (
          <button
            style={{
              padding: '10px 15px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold',
              boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              transition: 'all 0.2s ease',
              fontSize: '14px',
            }}
            onMouseOver={(e) => (e.currentTarget.style.opacity = '0.9')}
            onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
            onClick={() => history.push('/print_custom', { selected })}
          >
            🖨️ Print {selected.length} {selected.length === 1 ? 'item' : 'items'}
          </button>
        )}
      </div>

      <StyledWrapper>
        <Header>
          Products
          {userType !== 'regular' && (
            <BtnLink link="/product_add" className="btn_add">
              <BsPlus /> &nbsp; Add new product
            </BtnLink>
          )}
        </Header>
        <div className="filter">
          <ProductFilter
            sortHandler={sortHandler}
            showFilter={showFilter}
            displayFilterHandler={displayFilterHandler}
            clearFilterHandler={clearInputsBetter}
          />
        </div>
        <div className="filter-wrapper">
          {showFilter && (
            <FilterRow
              filterValuesHandler={filterValuesHandler}
              filterSelectHandler={filterSelectHandler}
              types={types}
              filterInputs={filterInputs}
            />
          )}

          <ProductTable
            products={spltArray[currentPage - 1]}
            isLoading={isLoading}
            allTypes={types}
            modalHandler={modalHandler}
            printMode={printMode}
            selected={selected}
            setSelected={setSelected}
          />
        </div>
        <Pagination
          spltArray={spltArray}
          countHandler={countHandler}
          currentPage={currentPage}
        />{' '}
      </StyledWrapper>
    </>
  );
};

const StyledWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 3rem;
  margin: 0 auto;
  overflow: hidden;
  @media (max-width: 600px) {
    padding: 3rem 1.5rem;
  }
  h1 {
    font-weight: 400;
    margin-bottom: 2rem;
    @media (max-width: 600px) {
      font-size: 1.6rem;
    }
  }

  .filter-wrapper {
    overflow-x: scroll;
  }

  .btn-add-cont {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 1rem auto;
  }
`;

export default Home;
